// src/components/Ambient.jsx
// 3.40.2: a soft moving background for side panels (the icon strip on the
// left, the menu under your name), in the sign-in page's style: light teal
// and green that slowly shifts, and a few paper sheets drifting up like faxes
// going out. It sits behind the panel's content (the panel adds the class
// "cp-ambient-host"); the look is in App.jsx (.cp-ambient…). It stops for
// people who ask their computer for less motion.
// 3.63.0: the left and right strips add "cp-night": the new sign-in page's dark
// look (App.jsx .cp-night…); the menu under your name keeps the light one.
export default function Ambient({ sheets = 3 }) {
  return (
    <div className="cp-ambient" aria-hidden="true">
      <span className="cp-amb-blob a" /><span className="cp-amb-blob b" />
      {Array.from({ length: sheets }, (_, i) => <span key={i} className={`cp-amb-sheet s${i}`} />)}
    </div>
  );
}
